import { AnimatePresence, motion } from "motion/react";

import type { PositionsDrawerTab } from "#/store/app/positionsDrawer/positionsDrawerTab";
import { usePositionsDrawerTab } from "#/store/app/positionsDrawer/positionsDrawerTab";

import { EmptyState } from "./components/EmptyState/EmptyState";
import { Header } from "./components/Header/Header";

export interface ContentsProps {
  children: React.ReactNode;
  isEmpty: boolean;
  animateKey: string;
}

const emptyMessages: Record<PositionsDrawerTab, string> = {
  positions: "Your positions will show here",
  "open-orders": "Your open orders will show here",
  rfq: "All RFQ responses will show here",
};

// TODO: empty state should get removed from here and be shown in table level via emptyState prop
export const Contents: React.FC<ContentsProps> = ({
  children,
  isEmpty,
  animateKey,
}) => {
  const { positionsDrawerTab } = usePositionsDrawerTab();

  if (isEmpty)
    return <EmptyState description={emptyMessages[positionsDrawerTab]} />;

  return (
    <>
      <Header />
      <AnimatePresence mode="wait">
        <motion.div
          key={animateKey}
          exit={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          initial={{ opacity: 0 }}
          transition={{ duration: 0.15, ease: "easeIn" }}
          className="flex flex-1 flex-col overflow-hidden"
        >
          {children}
        </motion.div>
      </AnimatePresence>
    </>
  );
};
